import { render, staticRenderFns } from "./avistamento-form.vue?vue&type=template&id=98d15fac"
import script from "./avistamento-form.vue?vue&type=script&lang=js"
export * from "./avistamento-form.vue?vue&type=script&lang=js"
import style0 from "./avistamento-form.vue?vue&type=style&index=0&id=98d15fac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports